import TypeMultiply from '../AnswerTypeMultiply/index';
import moment from 'moment';

class TypeMonths extends TypeMultiply {
	getData(){
		return moment.months();
	}
}

export default TypeMonths;



// WEBPACK FOOTER //
// ./src/components/AnswerTypeMonths/TypeMonths.js